// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-page-templates-page-page-js": () => import("./../src/page-templates/Page/Page.js" /* webpackChunkName: "component---src-page-templates-page-page-js" */),
  "component---src-page-templates-subpage-subpage-js": () => import("./../src/page-templates/Subpage/Subpage.js" /* webpackChunkName: "component---src-page-templates-subpage-subpage-js" */)
}

